import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { Layer } from '../shared/layers';

@Component({
  selector: 'igo-layer-legend',
  template: require('./layer-legend.component.html'),
  styles: [require('./layer-legend.component.styl')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayerLegendComponent {

  @Input()
  get layer(): Layer { return this._layer; }
  set layer(value: Layer) {
    this._layer = value;
    this._legend = value.dataSource.getLegend();
  }
  private _layer: Layer;

  get legend() {
    if (this._legend && this._legend.display === false) {
      return [];
    }
    return this._legend;
  }
  private _legend;

  constructor() {}

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/layer/layer-legend/layer-legend.component.ts